<h4 id="assignment-checks">{{ 'assignment.phase.checks' | transloco }}</h4>
<table aria-labelledby="assignment-checks">
	@if (errorAreas().length === 0) {
		<tr>
			<th>{{ 'assignment.phase.no_errors' | transloco }}</th>
		</tr>
	} @else {
		<tr>
			<th>{{ 'assignment.phase.errors_found' | transloco }}</th>
		</tr>
	}
	@for (area of errorAreas(); track area) {
		@let data = getErrorsOfArea(area);
		@for (error of data.errors; track error.message) {
			<tr>
				<td>
					@if (!error.validLink) {
						{{ error.message }}
					} @else {
						<a
							class="btn-link"
							[routerLink]="error.route"
							[queryParams]="queryParams"
							(click)="showToastMessage(error.toastMessageKey)"
						>
							{{ error.message }}
							<mat-icon class="material-symbols-outlined" [inline]="true" [aria-hidden]="true">arrow_forward</mat-icon>
						</a>
					}
				</td>
			</tr>
		}
	}
</table>
